import axiosNewApi from "config/axiosNewApi"

export const orderApi = {
    get: async () => {
        const response = await axiosNewApi.get("/mobile/orders" , {
            withCredentials: true
        })
        return response.data
    },
    getByRef: async (reference) => {
        const response = await axiosNewApi.get(`/mobile/orders?ref=${reference}` , {
            withCredentials: true
        })
        return response.data
    },
    getOrderDetails: async (id) => {
        const response = await axiosNewApi.get(`/mobile/orders/${id}` ,{
            withCredentials: true
        })
        return response.data
    },

}